// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__1ZH4t","inputLabel":"styles_inputLabel__26YkO","input":"styles_input__1FfBB"};